import Content, { ContentNS } from "content/content";

const useGenderOptions = () => {
  const clientsWithoutUnspecifiedGender = ["BA"];

  const text = (s: string) => Content.shared.t(s, { ns: ContentNS.passport });

  const options = [
    { label: text("male"), value: "M" },
    { label: text("female"), value: "F" },
  ];

  if (
    clientsWithoutUnspecifiedGender.includes(process.env.REACT_APP_CLIENT || "")
  ) {
    return options;
  }

  options.push({ label: text("unspecified"), value: "X" });
  return options;
};

export default useGenderOptions;
